import { startLogin } from "./api";
import s from "./LoginScreen.module.css";

// Full-viewport login screen. Shown when /api/me returns 401. The
// "Sign in with Google" button kicks off the OIDC flow at the Bun
// proxy; after the round-trip we land back on the SPA and the gate
// re-checks /api/me.
export function LoginScreen() {
  return (
    <div class={s.wrap}>
      <div class={s.card}>
        <div class={s.brand}>
          <svg class={s.brandIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <defs>
              <linearGradient id="login-grad" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stop-color="#6366f1" />
                <stop offset="50%" stop-color="#8b5cf6" />
                <stop offset="100%" stop-color="#06b6d4" />
              </linearGradient>
            </defs>
            <rect x="3" y="5" width="18" height="16" rx="3" stroke="url(#login-grad)" stroke-width="2" />
            <path d="M3 10 H21" stroke="url(#login-grad)" stroke-width="2" />
            <path d="M8 3 V7" stroke="url(#login-grad)" stroke-width="2" stroke-linecap="round" />
            <path d="M16 3 V7" stroke="url(#login-grad)" stroke-width="2" stroke-linecap="round" />
          </svg>
          <h1 class={s.title}>Operations Dashboard</h1>
        </div>
        <p class={s.lede}>Sign in with your authorised Google account to continue.</p>
        <button type="button" class={s.button} onClick={() => startLogin()}>
          <svg class={s.googleIcon} viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.717v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.616z" fill="#4285F4"/>
            <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
            <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
            <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958l3.007 2.332C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
          </svg>
          Sign in with Google
        </button>
        <p class={s.footnote}>
          Access is limited to a small allowlist. If you need access, contact the operator.
        </p>
      </div>
    </div>
  );
}
